"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initialize = void 0;
var i18next_formatters_1 = require("@equiem/i18next-formatters");
var union_1 = __importDefault(require("lodash/union"));
var merge_1 = __importDefault(require("lodash/merge"));
var config_1 = require("./config");
var debugLanguages_1 = require("./debugLanguages");
function initialize(instance, _a) {
    var _b;
    var defaultNS = _a.defaultNamespace, _c = _a.availableNamespaces, ns = _c === void 0 ? [defaultNS] : _c, languages = _a.languages;
    return __awaiter(this, void 0, void 0, function () {
        var resources, debugResources, initPromise;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (instance.isInitialized) {
                        return [2 /*return*/];
                    }
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    if (((_b = languages[config_1.defaultLocale]) === null || _b === void 0 ? void 0 : _b[defaultNS]) == null) {
                        throw new Error("missing default locale");
                    }
                    resources = (0, merge_1.default)({}, config_1.errorLanguages, languages);
                    debugResources = (0, debugLanguages_1.makeDebugLanguages)(resources, config_1.defaultLocale);
                    initPromise = instance.init({
                        fallbackLng: config_1.defaultLocale,
                        ns: (0, union_1.default)(ns, [config_1.serverMessagesNamespace]),
                        defaultNS: defaultNS,
                        interpolation: {
                            escapeValue: false,
                            skipOnVariables: false,
                        },
                        resources: __assign(__assign({}, debugResources), resources),
                    });
                    (0, i18next_formatters_1.applyFormatters)(instance);
                    return [4 /*yield*/, initPromise];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.initialize = initialize;
